<section id="form">
  <form [formGroup]="formulario" class="form container bg-color-light-grey color-dark"
    (ngSubmit)="onSubimitFormulario()">
    <h1 class="form-title text-center">Ajude a melhorar o catálogo</h1>
    <div class="form-group">
      <label class="form-label">
        Nome*:
        <app-required-text formControlName="nome" name="nome"></app-required-text>
      </label>
    </div>

    <div class="form-group">
      <label class="form-label">
        E-mail*:
        <app-required-text formControlName="email" name="email" id="email"></app-required-text>
      </label>
    </div>

    <div class="form-group">
      <label class="form-label">
        Instituição/Empresa:
        <input type="text" class="form-control" formControlName="instituicaoEmpresa" />
      </label>
    </div>

    <div class="form-group">
      <label class="form-label">
        Sua sugestão é para*:
        <select formControlName="sugestaoPara" class="form-control select">
          <option [ngValue]="null" disabled selected>Selecione...</option>
          <option *ngFor="let local of localAlteracao" [ngValue]="local">{{ local }}</option>
        </select>
      </label>

      <ng-container *ngIf="!formulario.get('sugestaoPara').valid && formulario.get('sugestaoPara').touched">
        <span class="color-red error-msg"> O preenchimento desse campo é obrigatório </span>
      </ng-container>
    </div>

    <ng-container *ngIf="formulario.get('sugestaoPara').value === 'Navegabilidade do site'">
      <div class="form-group">
        <label class="form-label">Proposta e Justificativa*:
          <app-custom-textarea [display]="true" formControlName="sugestaoNavegabilidade"></app-custom-textarea>
        </label>
      </div>
    </ng-container>

    <ng-container *ngIf="
        formulario.get('sugestaoPara').value === 'Eixo Tecnológico' ||
        formulario.get('sugestaoPara').value === 'Curso'
      ">
      <div class="form-group">
        <label class="form-label">
          Eixo Tecnológico*:
          <select formControlName="eixoTecnologicoCnctId" class="form-control select" id="eixo">
            <option [ngValue]="null" disabled selected>Selecione o Eixo Tecnológico</option>
            <option *ngFor="let eixo of eixos" [ngValue]="eixo.id">{{ eixo.nome }}</option>
          </select>
        </label>
        <ng-container *ngIf="
            !formulario.get('eixoTecnologicoCnctId').valid &&
            formulario.get('eixoTecnologicoCnctId').touched
          ">
          <span class="color-red error-msg"> O preenchimento desse campo é obrigatório </span>
        </ng-container>
      </div>
    </ng-container>

    <ng-container *ngIf="formulario.get('sugestaoPara').value === 'Eixo Tecnológico'">
      <div class="form-group">
        <label class="form-label">Proposta e Justificativa*:
          <app-custom-textarea [display]="true" formControlName="sugestaoEixo"></app-custom-textarea>
        </label>
      </div>
    </ng-container>

    <ng-container *ngIf="formulario.get('sugestaoPara').value === 'Curso'">
      <div class="form-group">
        <label class="form-label">
          Curso*:
          <select formControlName="cursoCnctId" class="form-control select" id="cursos">
            <option [ngValue]="null" disabled selected>Selecione o Curso</option>
            <option *ngFor="let curso of cursos" [ngValue]="curso.id">{{ curso.nome }}</option>
          </select>
        </label>
      </div>
    </ng-container>

    <ng-container *ngIf="
        formulario.get('cursoCnctId').dirty && formulario.get('sugestaoPara').value === 'Curso'
      ">
      <h2 class="form-subtitle text-center">
        Selecione "Adicionar sugestão" para os itens que você deseja enviar uma contribuição
      </h2>
      <div class="form-group" *ngFor="let campo of camposCurso">
        <app-custom-textarea [formControlName]="campo.field" [label]="campo.label" [id]="campo.field"
          [name]="campo.field" [alias]="campo.checkbox" (campoAdicionado)="addField($event)"></app-custom-textarea>
      </div>
    </ng-container>
    <div class="recaptcha">
      <re-captcha formControlName="reCaptcha" siteKey="6LemSscZAAAAAGVC1bDTsEe1L9VI1ZsM6zoOZR_5"></re-captcha>
    </div>
    <div class="wrapper">
      <button class="btn btn-md rounded-pill btn-dark cursor-pointer" [ngClass]="{ shake: formErro }" id="botao-form"
        role="button">
        Enviar
      </button>
    </div>
    <app-popup [resposta]="resposta" [mostrarPopUp]="mostarPopUp" (cancel)="cancelar()" (submit)="onSubimitFormulario()"
      [erro]="erro"></app-popup>
  </form>
</section>